import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>

    :host {
        display: block;
        padding: 15px 0;
        --primary-active: #00233C;
    }

    :host .headerContainer {
        display: flex;
    }

    :host .headerContainer #title > h1 {
        font-size: var(--type28_-_font-size);
        line-height: var(--font28-line-height);
        font-family: var(--font-family-black);
    }

    :host([adaptive='xs']) .headerContainer #title > h1 {
        font-size: var(--type24_-_font-size);
        line-height: var(--font24-line-height);
        font-family: var(--font-family-black);
    }

    :host .headerContainer.hasCloseButton #title {
        width: 80%;
    }

    :host([adaptive='xs']) .headerContainer.hasCloseButton #closeButton {
        display: block;
        width: 20%;
        text-align: right;
        color: var(--active-grey);
    }

    :host([adaptive='xs']) .headerContainer.hasCloseButton #closeButton > a {
        color: var(--active-grey);
    }

    :host #disclaimer {
        display: block;
        margin-top: 5px;
        max-width: 740px;
        font-size: var(--type16_-_font-size);
        font-family: var(--font-family-roman);
    }

    :host([adaptive='xs']) h3#disclaimer {
        margin-top: 0;
    }

    :host com-radio-group {
        padding: 25px 0 0;
    }

    :host com-radio-group com-button {
        width: auto;
        height: auto;
        max-width: unset;
        padding: 10px 30px;
        margin: 0 15px 15px 0;
        border-radius: 100px;
        line-height: 22px;
        font-family: var(--font-family-heavy);
    }

    :host([adaptive='xs']) com-radio-group com-button {
        width: 100%;
        margin-left: 0;
    }
</style>
</template>`;

styleElement.register('com-avl-cal-awakening-selector-style');